<template>
    <div class="requerimento" v-if="!loading">

        <!--
            Prévia no layout da impressão (pdf/historico-escolar). Os ícones de lápis abrem a
            edição: notas/faltas/carga horária no ano (cabeçalho da coluna), estudos realizados
            na linha do ano, observações e parecer final no quadro de observações.
        -->
        <div class="hist">

            <!-- CABEÇALHO + CERTIFICADO -->
            <table class="hist-caixa">
                <tr>
                    <td class="hist-cab-esq">
                        <table class="hist-cab">
                            <tr>
                                <td rowspan="7" class="hist-logo"><img :src="`${$store.state.config.baseUrlApi}/relatorios/img/logo.png`"></td>
                                <td colspan="2"><b>{{ imp.municipio_cabecalho }}</b></td>
                            </tr>
                            <tr><td colspan="2"><b>{{ imp.secretaria }}</b></td></tr>
                            <tr><td colspan="2"><b>{{ escola.nome }}</b></td></tr>
                            <tr>
                                <td style="width: 55%;"><b>ENDEREÇO:</b> {{ escola.endereco }}</td>
                                <td><b>EMITIDO EM:</b> {{ imp.emitido_em }}</td>
                            </tr>
                            <tr>
                                <td><b>BAIRRO:</b> {{ escola.bairro }}</td>
                                <td><b>CEP:</b> {{ escola.cep }}</td>
                            </tr>
                            <tr>
                                <td><b>CIDADE:</b> {{ escola.cidade }}</td>
                                <td><b>FONE:</b> {{ escola.fone }}</td>
                            </tr>
                            <tr>
                                <td><b>EMAIL:</b> {{ escola.email }}</td>
                                <td><b>INEP:</b> {{ escola.inep }}</td>
                            </tr>
                        </table>
                    </td>
                    <td class="hist-cab-dir"></td>
                </tr>
                <tr><td colspan="2" class="hist-titulo-cert">{{ imp.titulo }}</td></tr>
                <tr><td colspan="2" class="hist-linha">Autorização ou Reconhecimento do Curso: {{ imp.autorizacao }}</td></tr>
                <tr><td colspan="2" class="hist-texto">{{ imp.texto_certificado }}</td></tr>
            </table>

            <h1 class="hist-h1">HISTÓRICO ESCOLAR</h1>

            <!-- NOTAS -->
            <table class="hist-notas">
                <thead>
                    <tr>
                        <th class="hist-disc" style="width: 26%;">DISCIPLINA</th>
                        <th v-for="ref in refs" :key="'h' + ref" class="u-pointer" title="Editar notas, faltas e carga horária" @click="showDialogEditNotas(ref)">
                            {{ rotuloSerie(ref) }} <i class="fas fa-edit hist-lapis"></i>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(disc, i) in disciplinasUnificadas" :key="disc.chave" :class="{ 'hist-par': i % 2 == 1 }">
                        <td class="hist-disc">{{ disc.nome }}</td>
                        <td v-for="ref in refs" :key="disc.chave + ref">{{ disc.valores[ref] }}</td>
                    </tr>
                    <tr v-if="!disciplinasUnificadas.length">
                        <td class="hist-disc">-</td>
                        <td v-for="ref in refs" :key="'v' + ref">-</td>
                    </tr>
                    <tr class="hist-separador"><td :colspan="refs.length + 1"></td></tr>
                    <tr v-for="linha in linhasRodape" :key="linha.chave" class="hist-rodape">
                        <th class="hist-disc">{{ linha.rotulo }}</th>
                        <td v-for="ref in refs" :key="linha.chave + ref">{{ linha.valor(ref) }}</td>
                    </tr>
                </tbody>
            </table>

            <!-- ESTUDOS REALIZADOS -->
            <table class="hist-caixa hist-estudos">
                <tr>
                    <th style="width: 15%; text-align: center;">ANO</th>
                    <th style="width: 11%; text-align: center;">ANO LETIVO</th>
                    <th style="width: 44%;">ESTABELECIMENTO DE ENSINO</th>
                    <th style="width: 24%;">MUNICÍPIO</th>
                    <th style="width: 6%; text-align: right;">UF</th>
                </tr>
                <tr v-for="ref in refs" :key="'e' + ref">
                    <td class="u-pointer" style="text-align: center; white-space: nowrap;" title="Editar estudos realizados" @click="showDialogEstudosRealizados(ref)">
                        {{ rotuloSerie(ref) }} <i class="fas fa-edit hist-lapis"></i>
                    </td>
                    <td style="text-align: center;">{{ valorOuTraco(notas[ref].ano) }}</td>
                    <td>{{ valorOuTraco(notas[ref].unidade_ensino) }}</td>
                    <td>{{ valorOuTraco(notas[ref].cidade) }}</td>
                    <td style="text-align: right;">{{ valorOuTraco(notas[ref].UF) }}</td>
                </tr>
            </table>

            <!-- OBSERVAÇÕES -->
            <table class="hist-caixa hist-obs-caixa">
                <tr>
                    <td class="hist-obs">
                        <div class="hist-obs-acoes">
                            <span class="u-pointer" @click="showDialogObservacoes()"><i class="fas fa-edit hist-lapis"></i> observações</span>
                            <span class="u-pointer" @click="showDialogParecerFinal()"><i class="fas fa-edit hist-lapis"></i> parecer final</span>
                        </div>
                        Obs.:
                        <div v-for="(o, i) in observacoes" :key="'o' + i" class="hist-obs-item">{{ o }}</div>
                    </td>
                </tr>
            </table>

            <!-- LOCAL, DATA E ASSINATURAS -->
            <table class="hist-assinaturas">
                <tr>
                    <td style="width: 34%;">Município e Data: {{ imp.local_data }}</td>
                    <td style="width: 33%;">Secretário(a):</td>
                    <td style="width: 33%;">Diretor(a):</td>
                </tr>
            </table>
        </div>

            <el-row :gutter="10" class="u-mt-10">
                <el-col :xs="24" :sm="24" :md="24">
                    <div style="display: flex; justify-content: space-between;">
                        <el-button type="danger" plain @click="excluirHistorico()">
                            <i class="fas fa-trash-alt"></i> EXCLUIR HISTÓRICO
                        </el-button>
                        <el-button class="u-ml-10" @click="onSubmitHistoricoEscolar()">IMPRIMIR</el-button>
                    </div>
                </el-col>
            </el-row>

            <el-dialog :close-on-click-modal="false" title="IMPRESSÃO HISTÓRICO ESCOLAR" width="50%" :visible.sync="dialogEditNota" v-on:close="closeDialogEditNota" append-to-body>
                <div v-if="dialogEditNota" style="margin-top: 20px;">

                    <el-form label-position="top">
                        <el-form-item label="Possui resolução?">
                            <el-select v-model="dados.grade.conteudo.notas[idNotaSelected].aprovado_por_resolucao" @change="onChangeSerieResolucao" style="width: 100%;">
                                <el-option :value="true" label="SIM"></el-option>
                                <el-option :value="false" label="NÃO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>

                    <!-- Faltas / Carga horária (editáveis; o sistema traz o padrão, o usuário pode alterar) -->
                    <el-form v-if="!dados.grade.conteudo.notas[idNotaSelected].aprovado_por_resolucao" label-position="top">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Faltas">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].total_faltas" @input="marcarFaltasManual" placeholder="-"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Carga horária anual">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].carga_horaria_anual" @input="marcarCargaManual" placeholder="-"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>

                    <!-- Série aprovada por resolução: texto livre no lugar das disciplinas -->
                    <template v-if="dados.grade.conteudo.notas[idNotaSelected].aprovado_por_resolucao">
                        <el-form label-position="top" class="u-mt-10">
                            <el-form-item label="Resolução">
                                <el-input type="textarea" autosize v-model="dados.grade.conteudo.notas[idNotaSelected].resolucao" @input="marcarResolucaoManual" placeholder="Informe a resolução"></el-input>
                            </el-form-item>
                        </el-form>
                        <el-row :gutter="10" class="u-mt-10">
                            <el-col :xs="24">
                                <div class="u-text-right">
                                    <el-button @click="onSubmitFormEditNota" native-type="submit">SALVAR</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </template>

                    <!-- Lançamento normal de notas/conceitos -->
                    <template v-else>
                        <!-- Disciplinas já lançadas na série (edita a média) -->
                        <div v-if="temDisciplinasExistentes" class="borda mt-10" style="border-top: none;">
                            <table class="tabela-nota linha-tabela ultima-linha">

                                <tr v-for="(nota, disciplina) in dados.grade.conteudo.notas[idNotaSelected].disciplinas" :key="disciplina">
                                    <th class="col-t-50 coluna-tabela border-top">
                                        <p>{{ dados.disciplinas[disciplina] || disciplina }}</p>
                                    </th>
                                    <th class="col-t-50 coluna-tabela border-top ultima-coluna">
                                        <p>
                                            <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].disciplinas[disciplina]" maxlength="191"></el-input>
                                        </p>
                                    </th>
                                </tr>

                            </table>
                        </div>

                        <!-- Novas disciplinas a adicionar -->
                        <el-form label-position="top" v-if="formNotaExterna.length">
                            <el-row :gutter="10" v-for="(item, i) in formNotaExterna" class="u-mt-5" :key="'nova-' + i">
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="Disciplina" :key="'disc-' + i">
                                        <el-input v-model="formNotaExterna[i].disciplina" maxlength="191" v-on:blur="formatData(i, 'disciplina')"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="11" :md="11">
                                    <el-form-item label="Nota" :key="'nota-' + i">
                                        <el-input v-model="formNotaExterna[i].nota" maxlength="191"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="1" :md="1" class="u-text-right">
                                    <el-button @click="removeDisciplina(i)" type="danger" plain style="margin-top: 21px;">
                                        <i class="fas fa-trash-alt"></i>
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                        <el-row :gutter="10" class="u-mt-10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-button @click="addDisciplina()" type="primary" plain>
                                    <i class="fas fa-plus"></i> ADICIONAR DISCIPLINA
                                </el-button>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <div class="u-text-right">
                                    <el-button @click="onSubmitFormEditNota" native-type="submit">SALVAR</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </template>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" title="GERENCIAR ESTUDOS REALIZADOS" width="70%" :visible.sync="dialogEstudosRealizados" v-on:close="closeDialogEstudosRealizados" append-to-body>
                <div v-if="dialogEstudosRealizados" style="margin-top: 20px;">
                    
                    <el-form label-position="top">
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Ano" prop="ano" key="ano">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].ano" maxlength="191"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>    
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Unidade de Ensino" prop="unidade_ensino" key="unidade_ensino">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].unidade_ensino" maxlength="191" v-on:blur="formatDataUnidade('unidade_ensino')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>  
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Cidade" prop="cidade" key="cidade">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].cidade" maxlength="191" v-on:blur="formatDataUnidade('cidade')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Estado" prop="UF" key="UF">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].UF" maxlength="191" v-on:blur="formatDataUnidade('UF')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row> 
                    </el-form>
                        
                    <el-row :gutter="10" class="u-mt-10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <div class="u-text-right">
                                <el-button @click="onSubmitEstudosRealizados()" native-type="submit">SALVAR</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" title="GERENCIAR OBSERVAÇÕES" width="70%" :visible.sync="dialogObservacoes" v-on:close="closeDialogObservacoes" append-to-body>
                <div v-if="dialogObservacoes" style="margin-top: 20px;">
                    
                    <el-form label-position="top">
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Observações" prop="observacoes" key="observacoes">
                                    <el-input type="textarea" autosize v-model="dados.grade.conteudo.observacoes"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>  
                    </el-form>                        
                    <el-row :gutter="10" class="u-mt-10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <div class="u-text-right">
                                <el-button @click="onSubmitObservacoes()" native-type="submit">SALVAR</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" title="GERENCIAR PARECER FINAL" width="70%" :visible.sync="dialogParecerFinal" v-on:close="closeDialogParecerFinal" append-to-body>
                <div v-if="dialogParecerFinal" style="margin-top: 20px;">

                    <el-form label-position="top">
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Parecer final" prop="parecer_final" key="parecer_final">
                                    <el-input type="textarea" autosize v-model="dados.grade.conteudo.parecer_final"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-row :gutter="10" class="u-mt-10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <div class="u-text-right">
                                <el-button @click="onSubmitParecerFinal()" native-type="submit">SALVAR</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>

        </div>
</template>
<script>
import Vue from 'vue'

import { identidadeMixin } from '@/shared/identidade'

export default {
    // SANEAMENTO DA FASE 2: identidade do município vem do backend.
    mixins: [identidadeMixin],

    props: ['aluno'],
    data: () => ({
        idNotaSelected: '',
        dialogEditNota: false,
        dialogEstudosRealizados: false,
        dialogObservacoes: false,
        dialogParecerFinal: false,
        loading: true,
        dados:{ },
        formNotaExterna: []
    }),
    computed: {
        // ---------- prévia no layout da impressão (espelha DiarioService::prepararImpressaoHistorico)
        imp () {
            return (this.dados && this.dados.impressao) ? this.dados.impressao : {}
        },
        escola () {
            return this.imp.escola || {}
        },
        notas () {
            return (this.dados && this.dados.grade && this.dados.grade.conteudo && this.dados.grade.conteudo.notas) ? this.dados.grade.conteudo.notas : {}
        },
        refs () {
            return Object.keys(this.notas).sort((a, b) => Number(a) - Number(b))
        },
        /** Mesma disciplina com grafias diferentes (MATEMÁTICA / MATEMATICA) vira uma linha só. */
        disciplinasUnificadas () {
            const grupos = {}
            const nomes = (this.dados && this.dados.disciplinas) ? this.dados.disciplinas : {}
            Object.keys(nomes).forEach(id => {
                const nome = String(nomes[id] || '')
                const chave = this.semAcento(nome)
                if (!grupos[chave]) grupos[chave] = { chave, nome, ids: [] }
                if (this.semAcento(grupos[chave].nome) === grupos[chave].nome && nome !== this.semAcento(nome)) grupos[chave].nome = nome
                grupos[chave].ids.push(String(id))
            })
            return Object.keys(grupos).sort().map(k => {
                const g = grupos[k]
                const valores = {}
                this.refs.forEach(ref => {
                    const serie = this.notas[ref] || {}
                    let valor = null
                    if (!serie.aprovado_por_resolucao) {
                        const discs = serie.disciplinas || {}
                        for (const id of g.ids) {
                            if (!this.vazio(discs[id])) { valor = discs[id]; break }
                        }
                    }
                    valores[ref] = valor === null ? '-' : valor
                })
                return { chave: g.chave, nome: g.nome, valores }
            })
        },
        linhasRodape () {
            const serieImp = ref => (this.imp.series && this.imp.series[ref]) ? this.imp.series[ref] : {}
            return [
                { chave: 'chf', rotulo: 'CARGA HORÁRIA FREQ.', valor: ref => { const c = this.cargas(ref); return c.freq === null ? '-' : this.fmtNum(c.freq) } },
                { chave: 'ch', rotulo: 'CARGA HORÁRIA', valor: ref => { const c = this.cargas(ref); return c.ch === null ? '-' : this.fmtNum(c.ch) } },
                { chave: 'dl', rotulo: 'DIAS LETIVOS', valor: ref => serieImp(ref).dias || '-' },
                { chave: 'pf', rotulo: '% FREQUÊNCIA', valor: ref => { const c = this.cargas(ref); return c.pct === null ? '-' : c.pct.toFixed(1).replace('.', ',') + '%' } },
                { chave: 'rf', rotulo: 'RESULTADO FINAL', valor: ref => serieImp(ref).resultado || '-' }
            ]
        },
        observacoes () {
            const c = (this.dados && this.dados.grade && this.dados.grade.conteudo) ? this.dados.grade.conteudo : {}
            const obs = []
            if (c.observacoes) obs.push(c.observacoes)
            ;(c.equivalencia || []).forEach(eq => { if (!this.vazio(eq)) obs.push('Equivalência: ' + eq) })
            this.refs.forEach(ref => {
                const n = this.notas[ref] || {}
                if (n.aprovado_por_resolucao && n.resolucao) obs.push(this.rotuloSerie(ref) + ': ' + n.resolucao)
            })
            if (c.parecer_final) obs.push('Parecer final: ' + c.parecer_final)
            if (c.parecer) obs.push(c.parecer)
            return obs
        },
        /**
         * Escola do histórico: a selecionada no sistema; para perfis sem escola (SMED, NTI,
         * Consulta), a escola da matrícula do aluno exibida na listagem.
         */
        instituicaoId () {
            const inst = this.$store.state.config.instituicao
            if (inst && inst.id) return inst.id
            const m = this.aluno && this.aluno.matriculas && this.aluno.matriculas.length ? this.aluno.matriculas[0] : null
            if (!m) return null
            return m.instituicao_id || (m.instituicao ? m.instituicao.id : null)
        },
        temDisciplinasExistentes () {
            if (!this.dados || !this.dados.grade || !this.dados.grade.conteudo) return false;
            const serie = this.dados.grade.conteudo.notas[this.idNotaSelected];
            return !!(serie && serie.disciplinas && Object.keys(serie.disciplinas).length > 0);
        }
    },
    mounted () {

        this.getDados()
    },
    methods:{
        vazio (v) {
            return v === null || v === undefined || v === '' || v === '-'
        },
        valorOuTraco (v) {
            return this.vazio(v) ? '-' : v
        },
        semAcento (t) {
            return String(t || '').toUpperCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ')
        },
        rotuloSerie (ref) {
            if (this.imp.series && this.imp.series[ref]) return this.imp.series[ref].rotulo
            return this.$CONSTANTS.CURSO_NACIONAL[ref] || ref
        },
        fmtNum (v) {
            return String(Math.round(v * 10) / 10).replace('.', ',')
        },
        /** Carga horária e frequência da série, com os valores (editáveis) do próprio histórico. */
        cargas (ref) {
            const n = this.notas[ref] || {}
            if (n.aprovado_por_resolucao) return { ch: null, freq: null, pct: null }
            const num = v => this.vazio(v) || isNaN(Number(String(v).replace(',', '.'))) ? null : Number(String(v).replace(',', '.'))
            const ch = num(n.carga_horaria_anual)
            const faltas = num(n.total_faltas)
            const freq = (ch !== null && faltas !== null) ? Math.max(0, ch - faltas) : null
            const pct = (freq !== null && ch > 0) ? Math.round(freq / ch * 1000) / 10 : null
            return { ch, freq, pct }
        },
        getDados(){

            this.loading = true;

            let i = this.instituicaoId;

            if(!i){
                this.loading = false;
                window.eventBus.$emit('alert', {msg: 'Não foi possível identificar a escola do aluno para o histórico.', type: 'warning'});
                this.$emit('closeModal');
                return;
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/get-dados-historico-escolar/${i}/${this.aluno.id}`, this.$store.getters.getHeaderAuth).then(response => {

                if(typeof response.data.erro !== 'undefined'){

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                    this.$emit('closeModal');

                }else{

                    this.dados = response.data;
                    this.loading = false;
                }
                
            }).catch((error) => { this.$store.commit('throwException', error); });
            
        },
        showDialogEditNotas(idNota) {
            this.idNotaSelected = idNota;

            const serie = this.dados.grade.conteudo.notas[idNota];

            // Garante reatividade dos campos (snapshots antigos podem não ter).
            if (!('aprovado_por_resolucao' in serie)) Vue.set(serie, 'aprovado_por_resolucao', false);
            if (!('resolucao' in serie)) Vue.set(serie, 'resolucao', null);
            if (!('total_faltas' in serie)) Vue.set(serie, 'total_faltas', null);
            if (!('carga_horaria_anual' in serie)) Vue.set(serie, 'carga_horaria_anual', null);

            // Garante que sejam objetos (não arrays).
            if (!serie.disciplinas || Array.isArray(serie.disciplinas)) Vue.set(serie, 'disciplinas', {});
            if (!serie.disciplinas_traducao || Array.isArray(serie.disciplinas_traducao)) Vue.set(serie, 'disciplinas_traducao', {});

            // Toda disciplina já existente no histórico (união de todas as séries) deve aparecer
            // nesta série para lançamento, mesmo que fique em branco — o usuário decide preencher.
            for (const key in this.dados.disciplinas) {
                if (!Object.prototype.hasOwnProperty.call(serie.disciplinas, key)) {
                    Vue.set(serie.disciplinas, key, '');
                }
                if (!Object.prototype.hasOwnProperty.call(serie.disciplinas_traducao, key)) {
                    Vue.set(serie.disciplinas_traducao, key, this.dados.disciplinas[key]);
                }
            }

            this.dialogEditNota = true;
        },
        closeDialogEditNota() {
            this.dialogEditNota = false;
            this.idNotaSelected = {};
            this.formNotaExterna = []
        },
        onChangeSerieResolucao(value) {
            const serie = this.dados.grade.conteudo.notas[this.idNotaSelected];
            // Marca como definição MANUAL (o backend não recomputa quando manual).
            Vue.set(serie, 'resolucao_manual', value);
            Vue.set(serie, 'aprovado_por_resolucao', value);
            if (!value) {
                // Desmarcou: limpa a resolução (volta a mostrar as disciplinas).
                Vue.set(serie, 'resolucao', null);
            } else if (serie.resolucao === undefined || serie.resolucao === null) {
                Vue.set(serie, 'resolucao', '');
            }
        },
        marcarResolucaoManual() {
            // Usuário editou o texto da resolução (mesmo que puxada do sistema) → vira override
            // manual, para o backend não recomputar e sobrescrever com a resolução do curso.
            const serie = this.dados.grade.conteudo.notas[this.idNotaSelected];
            Vue.set(serie, 'resolucao_manual', serie.aprovado_por_resolucao);
        },
        marcarFaltasManual() {
            // Usuário alterou as faltas → vira override manual (backend não recomputa).
            Vue.set(this.dados.grade.conteudo.notas[this.idNotaSelected], 'total_faltas_manual', true);
        },
        marcarCargaManual() {
            // Usuário alterou a carga → vira override manual (backend não recomputa).
            Vue.set(this.dados.grade.conteudo.notas[this.idNotaSelected], 'carga_horaria_anual_manual', true);
        },
        onSubmitFormEditNota() {

            const serie = this.dados.grade.conteudo.notas[this.idNotaSelected];

            // Garante que disciplinas / disciplinas_traducao sejam objetos (não arrays).
            if (!serie.disciplinas || Array.isArray(serie.disciplinas)) Vue.set(serie, 'disciplinas', {});
            if (!serie.disciplinas_traducao || Array.isArray(serie.disciplinas_traducao)) Vue.set(serie, 'disciplinas_traducao', {});

            // Anexa as novas disciplinas digitadas (ignora linhas em branco). As notas já
            // existentes são editadas direto pelos inputs (v-model), então não são tocadas.
            for (let i in this.formNotaExterna) {
                const nova = this.formNotaExterna[i];
                if (!nova.disciplina) continue;

                const chave = 'ext_' + this.idNotaSelected + '_' + Date.now() + '_' + i;

                Vue.set(this.dados.disciplinas, chave, nova.disciplina);
                Vue.set(serie.disciplinas, chave, nova.nota);
                Vue.set(serie.disciplinas_traducao, chave, nova.disciplina);
            }

            this.formNotaExterna = [];
            this.dialogEditNota = false;
        },
        addDisciplina() {
            this.formNotaExterna.push({
                disciplina: '',
                nota: ''
            });
        },
        removeDisciplina(i) {
            this.formNotaExterna.splice(i, 1);
        },        
        showDialogEstudosRealizados(idNota) {
            this.dialogEstudosRealizados = true;
            this.idNotaSelected = idNota;
        },
        closeDialogEstudosRealizados() {
            this.dialogEstudosRealizados = false;
            this.idNotaSelected = {};
        },
        onSubmitEstudosRealizados(){

            this.dialogEstudosRealizados = false;
        },   
        showDialogObservacoes() {
            this.dialogObservacoes = true;
        },
        closeDialogObservacoes() {
            this.dialogObservacoes = false;
        },
        onSubmitObservacoes(){

            this.dialogObservacoes = false;
        },
        showDialogParecerFinal() {
            // Garante reatividade caso o snapshot antigo não tenha o campo.
            if (typeof this.dados.grade.conteudo.parecer_final === 'undefined') {
                Vue.set(this.dados.grade.conteudo, 'parecer_final', null);
            }
            this.dialogParecerFinal = true;
        },
        closeDialogParecerFinal() {
            this.dialogParecerFinal = false;
        },
        onSubmitParecerFinal(){

            this.dialogParecerFinal = false;
        },
        formatData(i, field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.formNotaExterna[i][field])
                return false;

            if(size && this.formNotaExterna[i][field].length < size)
                this.formNotaExterna[i][field] = '';            

            this.formNotaExterna[i][field] = this.formNotaExterna[i][field].toUpperCase();

            this.formNotaExterna[i][field] = this.$removerAcentos(this.formNotaExterna[i][field]);
        },
        formatDataUnidade(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.dados.grade.conteudo.notas[this.idNotaSelected][field])
                return false;

            if(size && this.dados.grade.conteudo.notas[this.idNotaSelected][field].length < size)
                this.dados.grade.conteudo.notas[this.idNotaSelected][field] = '';            

            this.dados.grade.conteudo.notas[this.idNotaSelected][field] = this.dados.grade.conteudo.notas[this.idNotaSelected][field].toUpperCase();

            this.dados.grade.conteudo.notas[this.idNotaSelected][field] = this.$removerAcentos(this.dados.grade.conteudo.notas[this.idNotaSelected][field]);
        },
        onSubmitHistoricoEscolar() {

            const parecerFinal = this.dados.grade.conteudo.parecer_final;
            if (!parecerFinal || String(parecerFinal).trim() === '') {
                window.eventBus.$emit('alert', {msg: 'Informe o Parecer Final antes de imprimir o histórico.', type: 'warning'});
                return;
            }

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/storeHistoricoEscolar/${this.aluno.id}`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
            
                if(typeof response.data.erro !== 'undefined'){

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

                }else{

                    let i = this.instituicaoId;

                    window.eventBus.$emit('print', {url: '/api/diario/printHistoricoEscolar', param: {aluno_id: this.aluno.id, instituicao_id: i }});

                    this.$emit('closeModal');
                }

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },
        excluirHistorico() {

            this.$confirm('Isso vai apagar o histórico salvo, incluindo notas, estudos realizados e observações inseridos manualmente. Ao reabrir, o histórico será recriado apenas com os dados atuais do sistema. Deseja continuar?', 'Excluir histórico', {
                confirmButtonText: 'Excluir',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/diario/deleteHistoricoEscolar/${this.aluno.id}`, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);

                    if(typeof response.data.erro !== 'undefined'){
                        window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                        return;
                    }

                    window.eventBus.$emit('alert', {msg: 'Histórico excluído. Recriado com os dados do sistema.', type: 'success'});
                    this.getDados();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(() => {});

        },
    },
    components:{ }
}
</script>
<style scoped>
    /* Prévia no layout da impressão (pdf/historico-escolar). */
    .hist { font-size: 11px; color: #000; }
    .hist table { width: 100%; border-collapse: collapse; table-layout: auto; }
    /* Anula o "table, td, th { width: 100% }" do layout antigo deste componente, que
       esmagava as colunas sem largura definida (texto saindo na vertical). */
    .hist td, .hist th { width: auto; }
    .hist-caixa { border: 1px solid #555; }
    .hist-caixa td { padding: 3px 6px; vertical-align: top; }
    .hist td.hist-cab-esq { width: 78%; border-right: 1px solid #555; }
    .hist-cab td { padding: 1px 6px; }
    .hist td.hist-logo { width: 80px; vertical-align: middle !important; }
    .hist-logo img { width: 70px; }
    .hist-titulo-cert { text-align: center; font-weight: bold; border-top: 1px solid #555; }
    .hist-linha { border-top: 1px solid #555; }
    .hist-texto { text-align: justify; }
    .hist-h1 { text-align: center; font-size: 18px; font-weight: bold; margin: 14px 0 8px; }
    .hist-notas th, .hist-notas td { padding: 3px 6px; text-align: center; }
    .hist-notas thead th { border: 1px solid #555; font-weight: bold; white-space: nowrap; }
    .hist-notas .hist-disc { text-align: left; white-space: nowrap; }
    .hist-notas tr.hist-par td { background: #ececec; }
    .hist-notas .hist-separador td { background: #ececec; height: 10px; border-left: 1px solid #555; border-right: 1px solid #555; }
    .hist-notas .hist-rodape th, .hist-notas .hist-rodape td { border: 1px solid #555; }
    .hist-notas .hist-rodape th { font-weight: bold; }
    .hist-estudos th { font-weight: bold; padding: 3px 6px; border-bottom: 1px solid #555; text-align: left; }
    .hist-estudos td { border-bottom: 1px solid #ddd; }
    .hist-obs-caixa { margin-top: 4px; }
    .hist-obs { height: 160px; position: relative; }
    .hist-obs-acoes { position: absolute; right: 8px; top: 4px; color: #838383; }
    .hist-obs-acoes span { margin-left: 14px; }
    .hist-obs-item { margin-top: 4px; text-align: justify; }
    .hist-assinaturas { margin-top: 4px; }
    .hist-assinaturas td { border: 1px solid #555; padding: 4px 6px; }
    .hist-lapis { color: #838383; font-size: 10px; }


    p {
        font-size: 11px;
        font-weight: normal;
    }

    .resolucao-vertical-modal {
        writing-mode: vertical-rl;
        transform: rotate(180deg);
        white-space: nowrap;
        display: inline-block;
        font-size: 12px;
        padding: 6px 0;
    }

    b {
        font-weight: bold;
    }

    h3 {
        font-size: 13px;
        font-weight: bold;
    }

    h4 {
        font-size: 13px;
        font-weight: normal;
    }

    table, td, th {
        table-layout: auto;
        width: 100%;
    }

    .linha {
        padding-left: 10px;
        padding-right: 10px;
    }

    .primeira-linha {
        padding-top: 5px;
    }

    .linha-tabela {
        border-collapse: collapse;
        border-bottom: 1px solid black;
    }

    .ultima-linha {
        border-bottom: none;
    }

    .coluna-tabela {
        table-layout: auto;
        border-right: 1px solid black;
        text-align: left;
    }

    .ultima-coluna {
        border-right: none;
    }

    .quadro-interno {
        height: 115px;
    }

    .quadro-lateral {
        margin-left: 8px;
        margin-right: 8px;
        height: 115px;
    }

    .col-t-5 {
        width: 5%;
    }

    .col-t-10 {
        width: 10%;
    }

    .col-t-15 {
        width: 15%;
    }

    .col-t-20 {
        width: 20%;
    }

    .col-t-25 {
        width: 25%;
    }

    .col-t-30 {
        width: 30%;
    }

    .col-t-33 {
        width: 33%;
    }

    .col-t-35 {
        width: 35%;
    }

    .col-t-40 {
        width: 40%;
    }

    .col-t-42 {
        width: 42%;
    }

    .col-t-45 {
        width: 42%;
    }

    .col-t-50 {
        width: 50%;
    }

    .col-t-55 {
        width: 50%;
    }

    .col-t-60 {
        width: 60%;
    }

    .col-t-65 {
        width: 60%;
    }

    .col-t-70 {
        width: 70%;
    }

    .col-t-75 {
        width: 70%;
    }

    .col-t-80 {
        width: 80%;
    }

    .col-t-85 {
        width: 80%;
    }

    .col-t-90 {
        width: 90%;
    }

    .col-t-95 {
        width: 90%;
    }

    .col-t-100 {
        width: 100%;
    }

    .borda {
        overflow-x: hidden;
        border: 1px solid #000000;
        border-radius: 8px;
        /* margin-bottom: 3px; */
        font-weight: 700;
    }

    .center {
        text-align: center;
    }

    .top {
        padding-top: 20px;
    }

    .right {
        text-align: right;
    }

    .justify {
        text-align: justify;
    }

    h2 {
        font-size: 16px;
    }

    h1 {
        font-size: 18px;
        font-weight: normal;
    }

    html{
        /* margin:20px 50px; */
        margin: 25px 25px 25px 25px; /* top right bottom left */
    }

    h1,h2,h3,h4,th,td,p,div,b {
        margin: 0;
        padding: 0;
    }

    .linha-tabela p {
        margin: 2px 2px 3px 4px;
    }

    .borda {
        margin-bottom: 5px;
    }

    .margin-bottom-5 {
        margin-bottom: 8px;
    }

    .margin-bottom-10 {
        margin-bottom: 10px;
    }

    .small-font {
        font-size: 10px;
    }

    .tiny-font {
        font-size: 5px;
    }

    .linha-tracejada {
        border: none;
        border-top: 1px dotted black;
        color: #fff;
        background-color: #fff;
        height: 1px;
    }

    .mt-40{
        margin-top: 40px !important;
    }

    .mt-30{
        margin-top: 30px !important;
    }

    .mt-20{
        margin-top: 20px !important;
    }

    .mt-10{
        margin-top: 5px;
    }

    .mt-5{
        margin-top: 5px;
    }

    .pl-10{
        padding-left: 10px;
    }

    .border05{
        border-bottom: 0.5px solid #000;
    }

    .my-5{
        margin: 5px 0px;
    }

    .text-left{
        text-align: left !important;
    }

    .requerimento {
        font-family: "Arial", "Helvetica", "sans-serif";
        page-break-inside: avoid;
    }

    .page-break {
        page-break-after: always;
    }

    .page-break:last-child {
        page-break-after: auto;
    }

    .border-top {
        border-top: 1px solid #000;
    }

    .vertical{
        writing-mode: vertical-rl;
        transform: rotate(180deg);
    }
</style>